/* Mold Labs — predictive (live) search dropdown.
   Attaches to any input[data-ml-predictive]; renders product suggestions from
   Shopify's built-in /search/suggest.json as you type. Self-contained: builds
   its own DOM and paints directly on elements so store style-stripping can't
   blank it. No dependencies. */
(function () {
  var INK = '#0f0f0e', GREEN = '#5ccc78', GREEN_INK = '#2f9c57',
      MUTED = '#8a8a80', LINE = '#ecece5', SURFACE = '#ffffff';

  function money(cents) {
    // cents → "1 234 Kč" (Czech grouping, no decimals for whole amounts)
    var v = (cents / 100);
    var s = v.toFixed(v % 1 ? 2 : 0).replace('.', ',');
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return s + '\u00a0Kč';
  }

  function attach(input) {
    if (input.__mlPredict) { return; }
    input.__mlPredict = true;
    input.setAttribute('autocomplete', 'off');

    var form = input.closest('form');
    var panel = form && form.querySelector('[data-ml-predict-panel]');
    if (!panel) {
      panel = document.createElement('div');
      panel.setAttribute('data-ml-predict-panel', '');
      (form || input.parentNode).appendChild(panel);
    }

    // paint the panel directly (style-strip proof)
    Object.assign(panel.style, {
      position: 'absolute', left: '0', right: '0', top: 'calc(100% + 8px)', zIndex: '60',
      background: SURFACE, border: '1px solid ' + LINE, borderRadius: '14px',
      boxShadow: '0 20px 44px rgba(15,15,14,.16)', overflow: 'hidden',
      display: 'none', maxHeight: '420px', overflowY: 'auto',
      fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif"
    });
    if (getComputedStyle(form).position === 'static') { form.style.position = 'relative'; }

    var timer = null, lastQ = '', ctrl = null;

    function hide() { panel.style.display = 'none'; panel.innerHTML = ''; }
    function show() { panel.style.display = 'block'; }

    function label(text) {
      var d = document.createElement('div');
      Object.assign(d.style, {
        fontFamily: "'Space Mono', ui-monospace, monospace", fontSize: '9.5px',
        letterSpacing: '.14em', textTransform: 'uppercase', color: MUTED,
        padding: '14px 18px 8px'
      });
      d.textContent = text;
      return d;
    }

    function row(p) {
      var a = document.createElement('a');
      a.href = p.url;
      Object.assign(a.style, {
        display: 'flex', alignItems: 'center', gap: '13px', padding: '10px 18px',
        textDecoration: 'none', color: INK, borderTop: '1px solid ' + LINE
      });
      a.onmouseenter = function () { a.style.background = '#f7f7f4'; };
      a.onmouseleave = function () { a.style.background = 'transparent'; };

      var thumb = document.createElement('div');
      Object.assign(thumb.style, {
        width: '44px', height: '44px', flex: '0 0 44px', borderRadius: '8px',
        background: '#eeeee8', overflow: 'hidden'
      });
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image; img.alt = '';
        Object.assign(img.style, { width: '100%', height: '100%', objectFit: 'cover', display: 'block' });
        thumb.appendChild(img);
      }

      var mid = document.createElement('div');
      mid.style.flex = '1'; mid.style.minWidth = '0';
      var t = document.createElement('div');
      Object.assign(t.style, { fontSize: '14px', fontWeight: '600', color: INK, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' });
      t.textContent = p.title;
      var sub = document.createElement('div');
      Object.assign(sub.style, { fontFamily: "'Space Mono', monospace", fontSize: '10.5px', color: MUTED, marginTop: '2px' });
      sub.textContent = p.spec || (p.type || '');
      mid.appendChild(t); if (sub.textContent) { mid.appendChild(sub); }

      var price = document.createElement('div');
      Object.assign(price.style, { fontSize: '14px', fontWeight: '700', color: INK, whiteSpace: 'nowrap' });
      price.textContent = p.price;

      a.appendChild(thumb); a.appendChild(mid); a.appendChild(price);
      return a;
    }

    function viewAll(q) {
      var a = document.createElement('a');
      a.href = '/search?q=' + encodeURIComponent(q);
      Object.assign(a.style, {
        display: 'block', textAlign: 'center', padding: '13px', textDecoration: 'none',
        fontSize: '13px', fontWeight: '600', color: '#fff', background: INK, borderTop: '1px solid ' + LINE
      });
      a.onmouseenter = function () { a.style.background = GREEN_INK; };
      a.onmouseleave = function () { a.style.background = INK; };
      a.textContent = 'Zobrazit všechny výsledky pro „' + q + '“ →';
      return a;
    }

    function render(q, products) {
      panel.innerHTML = '';
      if (!products.length) {
        var none = document.createElement('div');
        Object.assign(none.style, { padding: '18px', fontSize: '13.5px', color: MUTED });
        none.textContent = 'Pro „' + q + '“ nic nenalezeno.';
        panel.appendChild(none);
        panel.appendChild(viewAll(q));
        show();
        return;
      }
      panel.appendChild(label('Produkty'));
      products.forEach(function (p) { panel.appendChild(row(p)); });
      panel.appendChild(viewAll(q));
      show();
    }

    function query(q) {
      if (ctrl) { ctrl.abort(); }
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (((data || {}).resources || {}).results || {}).products || [];
          var mapped = items.map(function (p) {
            var img = null;
            if (p.image) { img = p.image; }
            else if (p.featured_image && p.featured_image.url) { img = p.featured_image.url; }
            var priceCents = (p.price_min != null) ? p.price_min : p.price;
            return {
              title: p.title,
              url: p.url,
              image: img,
              type: p.type,
              price: (typeof priceCents === 'number') ? money(priceCents) : (p.price || '')
            };
          });
          render(q, mapped);
        })
        .catch(function (e) { if (e && e.name === 'AbortError') { return; } hide(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQ) { return; }
      lastQ = q;
      if (timer) { clearTimeout(timer); }
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { query(q); }, 180);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) { show(); }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) { hide(); }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); }
    });
  }

  function init() {
    document.querySelectorAll('input[data-ml-predictive]').forEach(attach);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
